import React from 'react'

export const ArrowIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
)

export const CheckCircleIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12.5l2.8 2.8L16 10" />
    </svg>
)

// Small lock for the "secure one-time sign-in" reassurance line (trust cue).
export const LockIcon: React.FC<{ size?: number }> = ({ size = 13 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
        <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    </svg>
)

// Self-contained SMIL-animated spinner — no external CSS keyframes needed.
export const Spinner: React.FC<{ size?: number }> = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
    >
        <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeOpacity="0.25"
        />
        <path
            d="M21 12a9 9 0 0 0-9-9"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
        >
            <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 12 12"
                to="360 12 12"
                dur="0.9s"
                repeatCount="indefinite"
            />
        </path>
    </svg>
)

// ---------------------------------------------------------------------------
// Brand marks — geometry taken verbatim from the Sama Design System Logo
// component (claude.ai/design). The symbol (a large filled circle + a small
// offset dot) is the brand's signature motif; we use it as a faint watermark
// in the viridian brand band and the wordmark as the light logo on it.
// ---------------------------------------------------------------------------

export const SamaSymbol: React.FC<{
    size?: number
    color?: string
    style?: React.CSSProperties
}> = ({ size = 48, color = 'currentColor', style }) => (
    <svg
        width={size}
        height={size * (60.27 / 48.25)}
        viewBox="0 0 48.25 60.27"
        fill={color}
        aria-hidden="true"
        style={style}
    >
        <circle cx="24.12" cy="24.36" r="24.12" />
        <circle cx="41.15" cy="53.5" r="6.78" />
    </svg>
)
